import React from 'react';
import { useRegistration } from './RegistrationContext';
export const TopBanner = () => {
  const {
    openPopup
  } = useRegistration();
  return <div className="pt-6 pb-4 px-4 max-w-3xl mx-auto" data-id="element-395">
      <div className="flex items-center justify-center mb-6" data-id="element-396">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs Logo" className="h-14 object-contain" data-id="element-397" />
      </div>
      <button onClick={openPopup} className="w-full border-2 border-blue-600 bg-blue-50 py-3 px-4 rounded-lg text-center font-bold text-blue-700 hover:bg-blue-100 transition-colors text-sm md:text-base" data-id="element-398">
        GRATIS WEBINAR VAN HONDEN GEDRAGSEXPERT - VANDAAG & MORGEN
      </button>
    </div>;
};